import ToolbarButton from "../toolbar/ToolbarButton";
import { useState, useEffect } from "react";
import { useCurrentSimulationResults } from "../../api/simulations";
import { useSimulation } from "../../contexts/SimulationContext";
import {useDate} from "../../contexts/DateContext";
import { useProject } from "../../api/project";
import dayjs from "dayjs";
import {useTimezone} from "../../contexts/TimezoneContext.tsx";
import { bboxFromBoundary } from "../../utils/boundaryUtils";

const RiskToLayer = (id: string, name: string) => {
  const [active, setActive] = useState(false);
  const [rasterSource, setRasterSource] = useState<any>(null);
  const [stale, setStale] = useState(false);
  const { selectedDate } = useDate();
  const { selectedTimezone } = useTimezone();
  const { data: simResults } = useCurrentSimulationResults();
  const { isSimulationComplete } = useSimulation();
  const results = simResults?.data?.results ?? [];
  const { project } = useProject();

  useEffect(() => {
    if (results.length > 0 && isSimulationComplete && project?.data) {
      const selectedDateOnly = selectedDate.format("YYYY-MM-DD");
      const matchingData = results.find((data) => {
        const frameDate = dayjs(data.start_date_time).tz(selectedTimezone);
        const frameDateString = frameDate.format("YYYY-MM-DD");
        return frameDateString === selectedDateOnly;
      });

      if (!matchingData || !matchingData.total_burnt_area_img) {
        setRasterSource(null);
        return;
      }

      // Use project bounds for the raster coordinates
      const bbox = bboxFromBoundary(project.data.boundary);
      if (!bbox) return;
      const { top, left, bottom, right } = bbox;

      setRasterSource({
        type: "image",
        url: matchingData.total_burnt_area_img,
        coordinates: [
          [left, top], // top left
          [right, top], // top right
          [right, bottom], // bottom right
          [left, bottom], // bottom left
        ],
      });
      setStale(true);
    }
  }, [results, isSimulationComplete, selectedDate, project]);

  const rasterLayerStyle = {
    id: id,
    type: "raster",
    source: rasterSource,
    paint: {
      "raster-opacity": 0.6,
      "raster-fade-duration": 0,
    },
  };

  const toolbarButton = (
    <ToolbarButton
      key={id}
      id={id}
      name={name}
      toggledOn={active}
      enabled={!!rasterSource && isSimulationComplete}
      onClick={() => setActive(!active)}
      icon={"unfold_less"}
    />
  );

  return {
    id: id,
    name: name,
    type: "raster",
    source: rasterSource,
    layerStyle: rasterLayerStyle,
    toolbarButton: toolbarButton,
    active: active,
    stale: stale,
    setStale: setStale,
  };
};

export default RiskToLayer;
